module.exports = __webpack_public_path__ + "img/ea-logo.801c9e91.png";